import Firebase from '../../../lib/Firebase';

export default {
  manage(city, cityZipcode) {
    const { zipcodes } = city;
    const { zipcode, locality } = cityZipcode;

    zipcodes.push({ zipcode, locality });

    const cityObj = {
      zipcodes
    };

    return Firebase.firestore()
      .collection('cities')
      .doc(city.docId)
      .update(cityObj);
  },

  deleteZipcode(city, zipcodeTobeDeleted) {
    let { zipcodes } = city;
    zipcodes = zipcodes.filter(zipcode => zipcode !== zipcodeTobeDeleted);

    const cityObj = {
      zipcodes
    };

    return Firebase.firestore()
      .collection('cities')
      .doc(city.docId)
      .update(cityObj);
  }
};



// WEBPACK FOOTER //
// ./src/pages/cities/Zipcodes/service.js